import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFB524",
      d: "M17.919 13.82a1.1 1.1 0 0 0-.32.97l.89 4.92a1.08 1.08 0 0 1-.45 1.08 1.1 1.1 0 0 1-1.17.08l-4.43-2.31a1.13 1.13 0 0 0-.5-.131h-.27a.812.812 0 0 0-.27.09l-4.43 2.321c-.22.11-.467.149-.71.11a1.112 1.112 0 0 1-.89-1.271l.89-4.92a1.119 1.119 0 0 0-.32-.979l-3.61-3.5a1.08 1.08 0 0 1-.27-1.13c.135-.396.477-.685.89-.75l4.97-.721c.378-.039.71-.269.88-.609l2.19-4.49c.052-.1.119-.192.2-.27l.09-.07a.671.671 0 0 1 .16-.13l.11-.04.17-.07h.42c.377.039.708.264.88.6l2.22 4.47c.16.327.47.554.83.609l4.97.721c.42.06.77.35.91.75.13.401.018.841-.29 1.13l-3.74 3.54Z"
    }, null, -1)
  ])))
}
export default { render: render }